<template>
  <v-row justify="center">
    <v-btn 
      text
      @click.stop="dialog = true"
    >
      <v-icon
        small
      >
        mdi-share-variant-outline
      </v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="680"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{source}}
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import api from '@/services/api'
export default {
  props: {
    contentMasterID: {
      type: String,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
    contentTypeID: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    source: null,
  }),
  watch: {
    dialog (v) {
      if (v) this.handleGetData()
    },
  },
  methods: {
    handleGetData () {
      this.source = null
      if (!this.contentMasterID) return
      api.getItem('dviewcontent', `private/${this.contentType === 'media' ? 'media' : 'messages'}/`,`${this.contentTypeID}/${this.contentMasterID}/share-content-source`)
        .then(response => {
          this.source = response.Name
        })
    },
  },
}
</script>

